import React from 'react';
import logo from '../../assets/Logo/GIGiFYbasicLogo.png';
import './LoadingOverlay.css';

const LoadingOverlay = ({ message = "Loading...", showProgress = false, progress = 0 }) => {

  return (
    <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true" aria-label={message}>
      <div className="loading-container">
        {/* Logo */}
        <img 
          src={logo} 
          alt="Gigify Logo" 
          className="loading-logo"
        />
        
        {/* Circular Animation */}
        <div className="loading-spinner">
          <div className="spinner-circle-orange"></div>
          <div className="spinner-circle-blue"></div>
        </div>

        {/* Progress Indicator */}
        {showProgress && (
          <div className="loading-progress">
            <div 
              className="progress-bar" 
              style={{ width: `${progress}%` }}
            ></div>
            <span className="progress-text">
              {Math.round(progress)}% {message}
            </span>
          </div>
        )}
        
        {/* Simple message for non-progress loading */}
        {!showProgress && (
          <div className="loading-message">
            <span className="loading-text">{message}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;